/* eslint-disable */
"use strict";

import { QFUtil } from "./../../components/util.js";
import QFLayoutHeader from "./header.js";
import QFLayoutSubheader from "./subheader.js";
import QFLayoutFooter from "./footer.js";

var QFLayoutContent = function() {
    // Private properties
    var _element;

	// Private functions
	var _getHeight = function() {
		var height;

		height = QFUtil.getViewPort().height;

        if (_element) {
            height = height - parseInt(QFUtil.css(_element, 'paddingTop')) - parseInt(QFUtil.css(_element, 'paddingBottom'));
        }

        height = height - QFLayoutHeader.getHeight();
        height = height - QFLayoutSubheader.getHeight();
        height = height - QFLayoutFooter.getHeight();

		return height;
	}

    // Public methods
	return {
		init: function(id) {
            _element = QFUtil.getById(id);
		},

		getHeight: function() {
			return _getHeight();
		},

        getElement: function() {
            return _element;
        }
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = QFLayoutContent;
}

export default QFLayoutContent;